define('pageListHack',['jquery'],
function ($) {
	$('.page-list-navigation').each(function(){
		$('.item:nth-child(4n+1)').addClass('IE-break');
		$('.item:nth-child(4n+2)').addClass('IE-Second-box');
		$('.item:nth-child(4n+3)').addClass('IE-Third-box');
		$('.item:nth-child(4n+4)').addClass('IE-Fourth-box');

	});
});
